import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PasscodeModalService {
  passcode$ = new Subject<void>();

  unlocked$ = new Subject<string>();

  portalLink = '';

  passcodePassed = false;

  passcodeError = '';

  showModal(portalLink: string) {
    this.portalLink = portalLink;
    this.passcodePassed = false;
    this.passcodeError = '';
    this.passcode$.next();
  }

  setPasscodePassed(passcodePassed: boolean) {
    this.passcodePassed = passcodePassed;
  }

  setPasscodeError(passcodeError: string) {
    this.passcodeError = passcodeError;
  }

  unlock() {
    this.unlocked$.next(this.portalLink);
  }
}
